import React from "react";
import styles from "./AdminSelectPlan.module.css";
import { TextComponent } from "../../../components";
import profile from "../../../assets/images/profile.png";
import building from "../../../assets/images/building.png";
import rocket from "../../../assets/images/rocket.png";
import BillingCard from "../../../components/BillingCard/BillingCard";
import Switch from "../../../components/Switch/Switch";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";
import { useNavigate } from "react-router-dom";
const AdminSelectPlan = () => {
  const navigate = useNavigate();

  const CardData = [
    {
      title: "Craftsman",
      logo: profile,
      price: "$7",
      list: [
        "Attendance Management",
        "Leave System Management",
        "Chat Support",
        "Expense Tracking",
        "Invoice Generate",
        "Purchase Generate",
        "Leave System Management",
      ],
    },
    {
      title: "Wholesale",
      price: "$50",
      logo: building,

      list: [
        "Number of licenses used  ",
        "Subscription tier label  .",
        "Subscription renewal date",
      ],
    },
    {
      title: "Commercial",
      logo: building,

      price: "$75",
      list: [
        "Number of licenses used  ",
        "Subscription tier label  .",
        "Subscription renewal date",
      ],
    },
    {
      title: "Professional",
      price: "$95",
      logo: rocket,
      list: [
        "Attendance Management",
        "Leave System Management",
        "Chat Support",
        "Expense Tracking",
        "Invoice Generate",
        "Purchase Generate",
        "Leave System Management",
      ],
    },
  ];

  return (
    <div className={styles.mainCont}>
      <div className={styles.subCont}>
        <div className={styles.row}>
          <HeadingComponent
            text={"Select Your Plan"}
            fontSize={"var(--heading-font-size)"}
            fontFamily={"Poppins-bold"}
          />
          <div className={styles.mini_row}>
            <TextComponent
              text={"Monthly"}
              color={"var(--text-secondary-color)"}
              fontFamily={"Inter-semibold"}
            />

            <Switch
              activeColor={"#F39C12"}
              inactiveColor={" #78788029"}
              size="small"
            />
            {/* <Switch defaultChecked onChange={onChange} handleBg={"#F39C12"} /> */}
            <TextComponent
              text={"Annually"}
              fontFamily={"Inter-semibold"}
              color={"var(--text-secondary-color)"}
            />
          </div>
        </div>
        <BillingCard Options={CardData} isNavigate onClick={() => navigate("/AdminPayments")} />

      </div>
    </div>
  );
};

export default AdminSelectPlan;
